<template>
  <Error v-if="shouldCreateWorkspace" error="should-create-workspace" />
  <section v-else id="meals">
    <MyMeals />
  </section>
</template>

<script>
import MyMeals from '../../components/Meals/MyMeals.vue';

export default {
  components: {
    MyMeals,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped src="./Meals.scss"></style>
